export const getTilesAmenities = (componentData) => {
    let items = [];
    for (const prop in componentData?.fields?.elements?.[0]?.fields) {
        if (prop !== "title") {
            let amenity = componentData?.fields?.elements?.[0]?.fields[prop];
            amenity?.forEach(el => items.push({imageTitle: el?.fields?.image?.fields?.title, imageUrl: el?.fields?.image?.fields?.file?.url, title: el?.fields?.title}));
        }
    }
    return {
        title: componentData?.fields?.title,
        gridColumns: componentData?.fields?.gridColumns,
        gridSpacing: componentData?.fields?.gridSpacing,
        bgColor: componentData?.fields?.backgroundColour,
        items
    };
};
